import { useState } from "react";
import "./DangerZone.css";

import {
  pauseBusiness,
  resumeBusiness,
} from "../../services/providerSettingsService";

const DangerZone = () => {
  const [loading, setLoading] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const handlePauseResume = async () => {
    try {
      setLoading(true);

      if (isPaused) {
        const res = await resumeBusiness();
        alert(res.message);
        setIsPaused(false);
      } else {
        const res = await pauseBusiness();
        alert(res.message);
        setIsPaused(true);
      }
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="danger-zone-page">

      <div className="page-header">
        <h2>Danger Zone</h2>
        <p>
          Sensitive actions that permanently affect your
          business.
        </p>
      </div>

      {/* Pause Business */}

      <div className="danger-card">

        <div className="danger-content">
          <h3>
            {isPaused
              ? "Resume Business"
              : "Pause Business"}
          </h3>

          <p>
            {isPaused
              ? "Your business is currently hidden from customers."
              : "Temporarily hide your business and stop receiving new orders."}
          </p>
        </div>

        <button
          className={
            isPaused
              ? "resume-btn"
              : "danger-btn"
          }
          disabled={loading}
          onClick={handlePauseResume}
        >
          {loading
            ? "Please wait..."
            : isPaused
            ? "Resume Business"
            : "Pause Business"}
        </button>

      </div>

      {/* Delete Foods */}

      <div className="danger-card">

        <div className="danger-content">
          <h3>Delete All Foods</h3>

          <p>
            Permanently remove every food item from your
            business.
          </p>
        </div>

        <button className="danger-btn" disabled>
          Coming Soon
        </button>

      </div>

      {/* Delete Business */}

      <div className="danger-card">

        <div className="danger-content">
          <h3>Delete Business</h3>

          <p>
            Remove your business profile while keeping
            your customer account.
          </p>
        </div>

        <button className="danger-btn" disabled>
          Coming Soon
        </button>

      </div>

      {/* Delete Account */}

      <div className="danger-card">

        <div className="danger-content">
          <h3>Delete Account</h3>

          <p>
            Permanently delete your account and all
            associated data.
          </p>
        </div>

        <button className="danger-btn" disabled>
          Coming Soon
        </button>

      </div>

    </div>
  );
};

export default DangerZone;